// generated by genversion
export var version = '3.6.0';
//# sourceMappingURL=version.js.map